import { restRequest } from 'common-src/features/rest/actions';
import { HttpMethods } from 'common-src/features/rest/constants';

export const getPatientHistoryEventsRequest = (query, params) =>
  restRequest({
    uri: 'patientHistoryEvents',
    query,
    method: HttpMethods.Get,
    ...params,
  });
